import { render, staticRenderFns } from "./ChapterWaiver.vue?vue&type=template&id=93ca7c5e&"
import script from "./ChapterWaiver.vue?vue&type=script&lang=js&"
export * from "./ChapterWaiver.vue?vue&type=script&lang=js&"
import style0 from "./ChapterWaiver.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports